import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ExpandableSection } from 'foundations-components/transitional/components/ExpandableSection';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useContext } from 'react';
import { AppContext } from '../../contexts/app/context';
import { ContactsPropsContext } from '../../contexts/contacts/PropsContext';
import { prettifyAppName } from '../../utils/general';
import ApiOutagePlaceholder from '../common/ApiOutagePlaceholder/ApiOutagePlaceholder';
import AttendeePrompt from './AttendeePrompt';
import ContactList from './ContactList';
import DraftAttendeesList from './DraftAttendeesList';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ContactsMainContent({
  getAssociations,
  openPreviewModalHandler,
  openAssociationModal,
  onClickAssociate,
  setPopupToUnmap
}) {
  const {
    canViewParticipants,
    isExternalOutage,
    draftAttendees,
    participants
  } = useContext(ContactsPropsContext);
  const {
    selectors: {
      isDraft
    },
    appName
  } = useContext(AppContext);
  if (isExternalOutage) {
    return /*#__PURE__*/_jsx(ApiOutagePlaceholder, {
      title: I18n.text('errors.externalOutage.title', {
        appName: prettifyAppName(appName)
      }),
      description: I18n.text('errors.externalOutage.description', {
        appName: prettifyAppName(appName)
      })
    });
  }
  if (canViewParticipants) {
    return /*#__PURE__*/_jsx(ExpandableSection, {
      indentation: "compact",
      defaultOpen: true,
      titleText: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          marginInlineEnd: "200",
          as: "h6",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `contactList.${isDraft ? 'guests' : 'participants'}`,
            options: {
              count: isDraft ? draftAttendees.length : participants.length
            }
          })
        }), canViewParticipants ? /*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `contactList.tooltip.${isDraft ? 'guestList' : 'list'}`
          }),
          children: /*#__PURE__*/_jsx(InfoIcon, {
            color: "icon-core-subtle",
            size: "300"
          })
        }) : null]
      }),
      children: isDraft ? /*#__PURE__*/_jsx(DraftAttendeesList, {
        draftAttendees: draftAttendees,
        openPreviewModal: openPreviewModalHandler,
        openAssociationModal: openAssociationModal,
        getAssociations: getAssociations
      }) : /*#__PURE__*/_jsx(ContactList, {
        "data-test-id": `${appName}-participants-list`,
        contacts: participants,
        onClickAssociate: onClickAssociate,
        setPopupToUnmap: setPopupToUnmap,
        showProfileLink: false,
        openPreviewModal: openPreviewModalHandler
      })
    });
  }
  return /*#__PURE__*/_jsx(AttendeePrompt, {});
}
export default ContactsMainContent;